// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1mCrR","col":"styles_col__2MTwq","fulfillmentStatus":"styles_fulfillmentStatus__a_v1G","emailCol":"styles_emailCol__12c2W"};